export enum MeasuringPointLinkStatus {
    Linked = "linked",
    NotLinked = "notLinked",
}

export enum FilterType {
    Organization = "organizations",
    Project = "projects",
    Type = "types",

    Date = "dates",
    General = "general",

    Priority = "priorities",
    Status = "status",
    Material = "material",
    Start = "start",
    End = "end",
    ParkingBan = "parkingBan",
    MachineWork = "machineWork",
}
